import type { FiatCurrency } from '@0xtorch/core'

/**
 * 電子決済手段として扱う暗号資産 ID 一覧
 */
export const paymentInstrumentCryptoIds = ['jpycoin', 'usd-coin'] as const

/**
 * 電子決済手段ごとの参照法定通貨 ID
 */
export const paymentInstrumentReferenceFiatIdMap = new Map<
  string,
  FiatCurrency['id']
>([
  ['jpycoin', 'jpy'],
  ['usd-coin', 'usd'],
])
